import { assign } from 'lodash-es';

interface JQuery {
  noty: any;
}
/**
 * This code brings up a Noty notification, but does it in such a way that it appears directly below the aptitude
 * Sub-Nav and looks like it belongs on the page rather than popping it up at the very top of the page.
 *
 * Be sure to include both of the following in your HTML for this use of Noty as part of the Nav/Sub-Nav:
 *   <script src="../js/components/noty/js/noty/jquery.noty.js"></script>
 *   <script src="../js/components/noty/js/noty/layouts/inline.js"></script>
 */
export default function NavMessagesFactory() {
  // This data structure is used to keep track of messages which are currently shown in the Nav area. It prevents
  // the same message from being shown multiple times until the user has closed it.
  // TODO: Replace this with a Set.
  let activeNotifications = {};

  return {
    // Feel free to use basic HTML in the message if needed. For example:
    // "<b>This is emphasized</b> - And this expands on the emphasized info."
    showNotification: function (text, options, type = 'notification') {
      if (activeNotifications[text]) {
        return;
      } else {
        return (activeNotifications[text] = ($('.notyContainer') as any).noty(
          assign(
            {},
            {
              text: text,
              type: type,
              closeWith: ['click', 'button'],
              callback: {
                onClose: function () {
                  delete activeNotifications[text];
                }
              }
            },
            options
          )
        ));
      }
    },

    showErrorMessage: function (text, options = {}) {
      return this.showNotification(text, options, 'error');
    },

    showInfoMessage: function (text, options = {}) {
      return this.showNotification(text, options, 'information');
    },

    showSuccessMessage: function (text, options = {}) {
      return this.showNotification(text, options, 'success');
    },

    showWarnMessage: function (text, options = {}) {
      return this.showNotification(text, options, 'warning');
    }
  };
}
